import axios from 'axios';
import { serialize, simpleAes } from '@/util/util';
import NProgress from 'nprogress'; // progress bar
import errorCode from '@/const/errorCode';
import router from '@/router/router';
import { Message } from 'element-ui';
import 'nprogress/nprogress.css';
import qs from 'qs';
import { baseUrl } from '@/config/env';
import store from '@/store'; // progress bar style
import { localPlatformKey, defaultPlatform } from '@/const/common';
import interceptorsExt from '@/router/axios-interception-ext';
axios.defaults.timeout = 30000;
// 返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

axios.defaults.baseURL = baseUrl;

// 自定义配置：是否显示全局loading
axios.defaults.globalLoading = true;
axios.defaults.globalErrMessage = true;
// NProgress Configuration
NProgress.configure({
  showSpinner: false,
});

// HTTPrequest拦截
axios.interceptors.request.use(
  (config) => {
    config.globalLoading && NProgress.start(); // start progress bar
    const isToken = (config.headers || {}).isToken === false;
    let token = store.getters.access_token;
    let userInfo = store.getters.userInfo;
    if (token && !isToken) {
      config.headers['Authorization'] = 'Bearer ' + token; // token
    }
    if (userInfo) {
      config.headers['UserId'] = simpleAes(userInfo.staffId);
    }

    if (
      config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
    ) {
      config.transformRequest = [
        function (data) {
          let ret = '';
          for (let it in data) {
            if (
              data[it] !== '' &&
              data[it] !== null &&
              data[it] !== undefined
            ) {
              ret +=
                encodeURIComponent(it) +
                '=' +
                encodeURIComponent(data[it]) +
                '&';
            }
          }
          return ret;
        },
      ];
    }

    if (config.method === 'post') {
      // uaa post接口加平台标识
      if (config.url.startsWith('/uaa')) {
        const params = config.params || {};
        params.platform =
          sessionStorage.getItem(localPlatformKey) || defaultPlatform; //dotAdminPlatform;
        config.params = params;
      }
      // headers中配置serialize为true开启序列化
      if (config.headers.serialize) {
        config.data = serialize(config.data);
        config.traditional = true;
        delete config.data.serialize;
      }
    }

    // 处理get 请求的数组 springmvc 可以处理
    if (config.method === 'get') {
      // /system相关的Get接口添加平台标识参数
      if (config.url.startsWith('/system') || config.url.startsWith('/uaa')) {
        const params = config.params || {};
        if (!params.platform) {
          params.platform =
            sessionStorage.getItem(localPlatformKey) || defaultPlatform; //dotAdminPlatform;
          config.params = params;
        }
      }
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// HTTPresponse拦截
axios.interceptors.response.use(
  (res) => {
    //router.push({path: '/error'})
    NProgress.done();
    const status = Number(res.status) || 200;
    const message = res.data.msg || errorCode[status] || errorCode['default'];
    if (status === 401) {
      store.dispatch('FedLogOut').then(() => {
        router.push({ path: '/login' });
      });
      return Promise.reject(new Error(message));
    }
    if (status !== 200 || res.data.code === 1) {
      if (res.config?.globalErrMessage) {
        Message({
          message: message,
          type: 'error',
        });
      }
      return Promise.reject(new Error(message));
    }
    // 接口拦截code为101时跳转一致性检查页面
    interceptorsExt(res);
    return res;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  },
);

export default axios;
